import {
  email,
  required,
  maxLength
} from 'vuelidate/lib/validators'

import axios from 'axios'

export default {
  data() {
    return {
      contactForm: {
        name: null,
        email: null,
        message: null,
        sent: false,
        sending: false
      },
    }
  },
  validations() {
    let validations = {
      contactForm: {
        name: {
          required
        },
        email: {
          required,
          email
        },
        message: {
          required,
          maxLength: maxLength(500)
        },
      }
    }

    return validations
  },
  methods: {
    submit() {
      const component = this

      component.$v.contactForm.$touch()

      if (component.$v.contactForm.$invalid) {
        let invalidField

        Object.keys(component.$v.contactForm.$params).some(function (item) {
          invalidField = Object.keys(component.$v.contactForm).find(key => component.$v.contactForm[key].$invalid);
          return invalidField
        })

        component.$scrollTo(document.getElementById(invalidField), 1000, {
          offset: -150,
        })
      } else {

        component.contactForm.sending = true;

        var contactUrl = '/' + window.Laravel.code + '/contact/send';
        axios.defaults.headers.common = {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': window.Laravel.csrfToken
        };
        axios.post(contactUrl, component.contactForm)
          .then(function (response) {
            component.contactForm.sent = true
            component.contactForm.sending = false
          })
          .catch(function (error) {
            console.log(error);
            component.contactForm.sent = false
            component.contactForm.sending = false
          });

        // setTimeout(function () {
        //   component.contactForm.sending = false;
        //   component.contactForm.sent = true;
        // }, 3000);
      }
    },
    clearForm() {
      this.contactForm.name = null;
      this.contactForm.email = null;
      this.contactForm.message = null;
      this.contactForm.sent = false;

      this.$v.contactForm.$reset();
    }
  }
}